module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30.02 0h-28C.914 0 0 .894 0 2v28c0 1.106.914 2 2.02 2h28c1.106 0 1.98-.894 1.98-2V2c0-1.106-.876-2-1.98-2zM28 20h-3.98c-1.106 0-2.02.894-2.02 2v3c0 .552-.428 1-.98 1h-10c-.554 0-1.02-.448-1.02-1v-3c0-1.106-.876-2-1.98-2H4V4h24v16zm-12.626-.356c.358.468.936.476 1.292.008L21.84 13c.358-.472.164-1-.43-1H18V7c0-.55-.428-1-.98-1h-2C14.466 6 14 6.45 14 7v5h-3.372c-.592 0-.786.53-.428 1l5.174 6.644z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/inbox-4.js
// module id = 1186
// module chunks = 14